angular.module('bribac.interceptors.offlineStatusText', [])

  .config(function(
    $httpProvider
  ) {
    $httpProvider.interceptors.push('offlineStatusTextInterceptor')
  })

  .factory('offlineStatusTextInterceptor', function(
    $q
  ) {
    return {

      responseError: function(response) {
        if (response.status === -1 && !response.statusText) {
          response.statusText = 'No internet connection'
        }
        return $q.reject(response)
      }

    }
  })
